
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecoflow-ambassador-program",
      function () {
        return require("private-next-pages/ecoflow-ambassador-program/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecoflow-ambassador-program"])
      });
    }
  